/** Shipment types allowed per transport mode (Geographic Routing UI). */

export const SHIPMENT_TYPES_BY_TRANSPORT_MODE = {
  ROAD: [
    { value: "FTL", label: "FTL" },
    { value: "LTL", label: "LTL" },
    { value: "DRAY", label: "DRAY" },
  ],
  SEA: [
    { value: "FCL", label: "FCL" },
    { value: "LCL", label: "LCL" },
  ],
  AIR: [
    { value: "AIR", label: "AIR" },
    { value: "PARCEL", label: "PARCEL" },
  ],
  RAIL: [
    { value: "INTERMODAL", label: "Intermodal" },
    { value: "CARLOAD", label: "Carload" },
    { value: "BOXCAR", label: "Boxcar" },
  ],
};

export const getShipmentTypeOptionsForMode = (mode) => {
  const key = (mode ?? "").toString().trim().toUpperCase();
  return SHIPMENT_TYPES_BY_TRANSPORT_MODE[key] || [];
};

/** If current type is invalid for mode, return first allowed type (or ""). */
export const coerceShipmentTypeForTransportMode = (mode, currentType) => {
  const options = getShipmentTypeOptionsForMode(mode);
  if (!options.length) return "";
  const upper = (currentType ?? "").toString().trim().toUpperCase();
  const match = options.find((o) => String(o.value).toUpperCase() === upper);
  return match ? match.value : options[0].value;
};
